import React from 'react';
import {observer} from 'mobx-react';
import {Panel, Avatar, ProgressIndicator, ActionLink} from 'components';
import {FormattedMessage} from 'react-intl';

const ProgressUpdateList = observer(({uiState}) => {
  const {goal} = uiState;

  return goal.sortedProgressUpdates.map(update =>  {
    return (
      <Panel key={update.id}>
        <div className='table'>
          <div className='col-11 table-cell pr2'>
            <div className='table-cell align-top pr2'>
              <Avatar size='sm' employee={update.user} />
            </div>
            <div className='table-cell align-top full-width'>
              <div className='h3 medium'>{update.user.name}</div>
              <div className='jumbo'>{update.createdAtView}</div>
              <div className='whitespace-pre-line mt2'>{update.comment}</div>
              {update.showProgressIndicator && <div className='relative mt2 mb1'>
                {update.completeness > 9 &&
                  <span style={{left: `${update.completeness - 7}%`}} className='absolute medium white bottom-0'>
                    {`${update.completeness}%`}
                  </span>}
                <ProgressIndicator items={update.progressBarItems} />
              </div>}
            </div>
          </div>
          {update.canDelete && <div className='col-1 table-cell align-top right-align'>
            <div className='px1 dropdown inline-block'>
              <i className='HoverAnimation-trigger--image h1 material-icons submarine align-middle' data-toggle='dropdown'>{'more_horiz'}</i>
              <ul className='dropdown-menu right-0'>
                <li>
                  <ActionLink onClick={() => uiState.openDeleteProgressUpdateModal(update)} className='py1 px2 regular jumbo'>
                    <FormattedMessage id='Delete'/>
                  </ActionLink>
                </li>
              </ul>
            </div>
          </div>}
        </div>
      </Panel>
    );
  });
});

export default ProgressUpdateList;
